import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightListFilter',
  pure: false
})
export class HighlightListFilterPipe implements PipeTransform {
  static ALL_VALUE = 'All';

  transform(value: any[], filter: any): any {
    if (filter === HighlightListFilterPipe.ALL_VALUE) {
      return value;
    }

    return value.filter(data => {
      if (data.types === false) {
        return false;
      }

      for (const menu of data.types) {
        if (filter.indexOf(menu) > -1) {
          return true;
        }
      }
    });
  }
}
